<template>
    <div class="float-left mr-1">
        <span class="text-success" v-if="irregularidade.ativa">
            <i
                class="fa fa-toggle-on fa-lg icon-button"
                title="Desativar Item"
                @click.stop="confirmaAtivarDesativarItem('D')"
            ></i>
        </span>
        <span class="text-secondary" v-if="!irregularidade.ativa">
            <i
                class="fa fa-toggle-off fa-lg icon-button"
                title="Ativar Item"
                @click.stop="confirmaAtivarDesativarItem('A')"
            ></i>
        </span>
    </div>
</template>

<script>
import IrregularidadesServicos from './IrregularidadesServicos'

export default {
    props: {
        irregularidade: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
        }
    },

    methods: {
        
        confirmaAtivarDesativarItem(operacao) {
            let titulo = `${
                operacao === 'A' ? 'Ativação' : 'Desativação'
            } de Item`
            let mensagem = `Confirma a ${
                operacao === 'A' ? 'ativação' : 'desativação'
            } do item?`
            
            this.$swal({
                title: titulo,
                html: mensagem,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.ativarDesativarItem()
                }
            })
        },

        ativarDesativarItem() {
            this.$store.dispatch('addRequest')
            IrregularidadesServicos.ativarDesativarIrregularidade(this.irregularidade).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterIrregularidadesAtualizadas')
                        } else {
                            this.$emit('atualizarMensagemErro', response.errors)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
